import { render, staticRenderFns } from "./ApprovalDetails.vue?vue&type=template&id=ec8581c6"
import script from "./ApprovalDetails.vue?vue&type=script&lang=js"
export * from "./ApprovalDetails.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDetails.vue?vue&type=style&index=0&id=ec8581c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports